import callApi from "Common/utils/apiCaller";
import React, { useState, useEffect } from "react";
import { showNotification } from "Common/utils/Notification";
import Button from "../ButtonComponent/Button";
import ImageData from "../customImage/ImageSegment";
import ImageView from "../ImageView/ImageView";
import Drawer from "../Drawer";
import { X } from "lucide-react";
import CustomInput from "../InputFields/CustomInput";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";

const NewsLetterSegments = ({
  pageId,
  data,
  handleDelete,
  loader,
  setLoader,
  isEditable,
  versionData,
  segmentId,
  segmentType,
  toggleVisiblity,
}) => {
  const [headerText, setHeaderText] = useState(data?.header_text);
  const [buttonText, setButtonText] = useState(data?.button_text);
  const [isLoading, setIsLoading] = useState<any>(false);
  const [errors, setErrors] = useState({
    headerText: "",
    buttonText: "",
  });
  const [imageData, setImageData] = useState<any>("");
  const [showImage, setShowImage] = useState<any>(false);
  const toggleImage = () => setShowImage(!showImage);
  const [backgroundImage, setBackgroundImage] = useState<any>(
    data?.background_image ? data?.background_image : ""
  );
  const [backgroundImageId, setBackgroundImageId] = useState<any>("");

  useEffect(() => {
    if (imageData && imageData?.media_url) {
      if (imageData?.media_type === "image") {
        setBackgroundImage(imageData.media_url);
        setBackgroundImageId(imageData._id);
        setErrors((prev) => ({ ...prev, ["background_image"]: "" }));
      } else {
        showNotification("Media type should be image", "error");
      }
    }
  }, [imageData]);

  const handleSave = async (pageId, id) => {
    const newErrors = {
      headerText: headerText.trim() === "" ? "Please enter header text." : "",
      buttonText: buttonText.trim() === "" ? "Please enter button text." : "",
    };

    setErrors(newErrors);

    if (!headerText) {
      return;
    }
    if (!buttonText) {
      return;
    }
    const payload = {
      segment_type: "newsletter_segments",
      background_image: backgroundImage,
      background_image_id: backgroundImageId,
      header_text: headerText,
      button_text: buttonText,
    };

    try {
      setIsLoading(true);
      const response = await callApi(
        `v1/page/${pageId}/segment/${id}/update-info`,
        "post",
        payload
      );
      setIsLoading(false);
      if (response && response?.status === "Success") {
        setLoader(!loader);
        showNotification("Newsletter added successfully!", "success");
      } else {
        showNotification("Something went wrong. Please try again.", "error");
      }
    } catch (e) {
      showNotification("An error occurred . Please try again.", "error");
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="bg-white border border-black-600 rounded-[5px] px-8 py-4">
        <ToggleSwitch
          selectValue={data?.is_visible}
          versionValue={versionData?.is_visible}
          toggle={() =>
            toggleVisiblity(pageId, segmentId, segmentType, !data?.is_visible)
          }
          label="Is Segment Visible?"
          required={true}
        />
        <div className="mb-4 xl:col-span-12">
          <CustomInput
            label="Heading"
            name="subHeaderText"
            type="text"
            value={headerText}
            placeholder="Enter heading"
            onChange={(e) => setHeaderText(e.target.value)}
            isVersioned={versionData ? true : false}
            versionedValue={versionData?.header_text}
            error={errors?.headerText}
          />
        </div>
        <div className="mb-4 xl:col-span-12">
          <CustomInput
            label="Button Text"
            name="buttonText"
            type="text"
            value={buttonText}
            placeholder="Enter button text"
            onChange={(e) => setButtonText(e.target.value)}
            isVersioned={versionData ? true : false}
            versionedValue={versionData?.button_text}
            error={errors?.buttonText}
          />
        </div>
        <div>
          <div className="flex my-4">
            {backgroundImage ? (
              <div className="flex items-center">
                <ImageData
                  imageLink={backgroundImage}
                  setImageData={setImageData}
                  setImageLink={setBackgroundImage}
                />
                <div className="h-3 ml-3">
                  <button
                    onClick={() => {
                      toggleImage();

                      setImageData(undefined);
                    }}
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    Change
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={() => {
                  toggleImage();

                  setImageData(undefined);
                }}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add BackgroundImage
              </button>
            )}
          </div>
          {/* {errors.image_url && (
            <p className="text-sm text-red-500">{errors.image_url}</p>
          )} */}
        </div>
        {/* Save Button */}
        <div className="flex justify-end gap-2 mt-4">
          <Button
            isLoading={isLoading}
            handleSave={handleSave}
            pageId={pageId}
            id={segmentId}
          />

          <button
            className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
            onClick={() => handleDelete(segmentId, data?.segment_type)}
          >
            Delete
          </button>
        </div>
      </div>
      <Drawer
        show={showImage}
        onHide={toggleImage}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Select Image"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <ImageView
            showImage={showImage}
            setEventData={setImageData}
            togleImage={toggleImage}
          />
        </Drawer.Body>
      </Drawer>
    </>
  );
};

export default NewsLetterSegments;
